export function encodeFiltersParam(filters: unknown): string {
  const json = JSON.stringify(filters);
  const b64 = btoa(unescape(encodeURIComponent(json)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function decodeFiltersParam(raw: string): unknown | null {
  try {
    const pad = raw.length % 4 === 0 ? "" : "=".repeat(4 - (raw.length % 4));
    const b64 = raw.replace(/-/g, "+").replace(/_/g, "/") + pad;
    const json = decodeURIComponent(escape(atob(b64)));
    return JSON.parse(json) as unknown;
  } catch {
    return null;
  }
}
